import { render, staticRenderFns } from "./layoutCollegeUser.vue?vue&type=template&id=b5eca002&"
import script from "./layoutCollegeUser.vue?vue&type=script&lang=js&"
export * from "./layoutCollegeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports